import { connect } from 'react-redux';

import { StoreState } from '../../reducers';
import ButtonCreateNote from '../../components/ButtonCreateNote';
import { getMenuButtonIconSrc } from '../../utils/menuManager';

const mapStateToProps = (state: StoreState, ownProps) => {
	const {
		notes: { editor: { isOpened } },
		galleryInfos: { config },
		driveList: { driveItems, resolutions },
		offlineManager: { thumbMap },
	} = state;
	const { icon } = ownProps;

	return {
		iconSrc: getMenuButtonIconSrc(icon, driveItems, config, thumbMap, resolutions),
		isActive: isOpened,
	};
};

export default connect(mapStateToProps)(ButtonCreateNote);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/ButtonCreateNote/index.tsx